// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".restoreCode[data-v-f51b2122]{width:192px;max-width:100%;margin:0 auto 10px}.modalInput[data-v-f51b2122]{text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
